<img [src]="image | resizeImage: [160, 160]" loading="lazy" />

<div *ngIf="renderOverlay" class="overlay">
  <div class="index">
    <span>{{ index + 1 }}</span>
    <div *ngIf="isAuctionList" class="auction-list-mark">
      {{ 'AUCTION_LIST' | translate }}
    </div>
  </div>
</div>
